import { Portal } from '@mui/material';
import type { PropsWithChildren } from 'react';

type MobiTitleProps = PropsWithChildren;

export const MobiTitle: React.FC<MobiTitleProps> = (props) => {
  const { children } = props;

  const dom = document.getElementById('user-title');
  if (dom) {
    return <Portal container={() => dom}>{children}</Portal>;
  }

  return null;
};
